export const ArtifactTypes = {
  ASSEMBLED: 'From CodaMetrix (preliminary)',
  CODED: 'From CAC',
  MAPPED: 'From dictionary lookups (internal)',
  CLINICAL: 'From source (HL7)',
  CLAIM: 'From catalog file',
  PREDICTION: 'From machine learning prediction',
  PROCESSED: 'From CodaMetrix',
  SUBMITTED: 'Sent to billing',
  REMITTANCE: 'From a response to the payer',
  REFERRAL: 'From referral',
  MANUAL: 'From manual',
  CQA: 'From CodaMetrix QA'
};

export const AmplifyInvoiceSourceHeader = {
  CLINICAL: 'From Source',
  MAPPED: 'From Rules',
  PREDICTION: 'From Prediction',
  PREDICTION_COMPONENT: 'From Prediction Component',
  ASSEMBLED: 'Assembled in Amplify'
};

export const AmplifyCodeSourceHeader = {
  CLINICAL: 'Provider Submitted Set',
  MAPPED: 'Rule Set',
  PREDICTION: 'CMX Predicted Set',
  CODED: 'Coder Set',
  PROCESSED: 'Processed Set',
  SUBMITTED: 'Submitted Set'
};

export const InvoiceTypes = {
  CLINICAL : 'CLINICAL',
  MAPPED : 'MAPPED',
  PREDICTION : 'PREDICTION',
  PREDICTION_COMPONENT : 'PREDICTION_COMPONENT',
  ASSEMBLED : 'ASSEMBLED',
  CODED : 'CODED',
  PROCESSED : 'PROCESSED',
  SUBMITTED : 'SUBMITTED',
};
